import { render, staticRenderFns } from "./PromotionHexIcon.vue?vue&type=template&id=6875ab07&scoped=true"
import script from "./PromotionHexIcon.vue?vue&type=script&lang=js"
export * from "./PromotionHexIcon.vue?vue&type=script&lang=js"
import style0 from "./PromotionHexIcon.vue?vue&type=style&index=0&id=6875ab07&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875ab07",
  null
  
)

export default component.exports